<template>
  <div>
    <div class="error-container align-self-center text-center">
      <b-img :src="WarningIcon" class="align-self-center text-center error-icon-container" alt="maintenance-icon" />
      <div class="error-message-container">
       <p class="maintenance-title">Website Under Maintenance</p>
        <p>
          {{ notificationMessage }}
        </p>
        <p v-if="isPlanned && formattedPlannedEndTime">
          Expected Resolution:
          <strong>{{ formattedPlannedEndTime }}</strong>
        </p>
        <p class="contact-text">If you have any questions, please <a :href="`mailto:${TeamEmail}`">contact the Financial Systems team</a>.</p>
      </div>
    </div>
  </div>
</template>
<style scoped>
.error-container {
  text-align: center;
  max-width: 90%;
  min-height: 450px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top:3rem !important;
  background-color: rgba(216, 216, 216, 0.2);
  padding-bottom: 2rem;
}
 .error-message-container {
  margin-top: 31px;
}
.error-message-container p {
  font-family: 'Open Sans';
  font-size: 25px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.02px;
  text-align: center;
  color: #4d5161;
}
.maintenance-title {
  font-weight: 600 !important;
  margin-bottom: 15px !important;
}
.error-icon-container {
  margin-top:3.66rem;
}
.error-message-container p {
  margin-bottom: 0px;
}
.contact-text {
    margin-top: 30px !important;
}
</style>
<script>
export default {
  name: "underMaintenance",
  props: {
    maintenanceInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      WarningIcon: require("@/assets/Icons/Warning.svg"),
      TeamEmail:process.env.VUE_APP_SUPPORT_MAIL
    };
  },
  computed: {
    isPlanned() {
      return this.maintenanceInfo ? this.maintenanceInfo.IsPlanned : false;
    },
    formattedPlannedEndTime() {
      if (!this.maintenanceInfo || !this.maintenanceInfo.PlannedEndTime) return '';
      var dt = new Date(this.maintenanceInfo.PlannedEndTime);
      return dt.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    },
    notificationMessage() {
      return this.maintenanceInfo ? this.maintenanceInfo.NotificationMessage : '';
    }
  },
  created() {},
};
</script>
